export default __webpack_public_path__ + "static/media/WhatsApp Video 2021-07-28 at 5.07.56 PM.08f1ec8c.mp4";